import React, { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import { saveAs } from "file-saver";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomSelect from "../../../components/main_comps/custom_select";
import { useSnackbar } from "notistack";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import { APPROVED, CLIENT } from "../../../../utility/constants/valueConstants";

///////test
const DownloadReportClient = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  const serviceProvider = useSelector(
    (state) => state.dropDownListSlice.serviceProviderNameList
  );

  const [selectedServiceProvider, setSelectedServiceProvider] = useState({
    label: "Select Provider Name",
    value: "",
  });

  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const [selectedClient, setSelectedClient] = useState({
    label: "Client Name",
    value: "",
  });
  const role = secureStorage.getItem(SS_ROLE);

  const clientOptions = [];
  const containerStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 55,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    maxWidth: "auto",
  };

  const { enqueueSnackbar } = useSnackbar();

  const onClickDownLoadReport = () => {
    if (fromDate && !toDate) {
      enqueueSnackbar("Please apply to date filter", {
        variant: "error",
      });
      return;
    }
    if (
      (fromDate && toDate) ||
      selectedClient.value ||
      selectedServiceProvider.value
    ) {
      setLoading(true);
      ApiRequestGet.downloadClientList({
        page: 1,
        size: 10,
        dateRange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
            "-" +
            moment(toDate).format("DD/MM/YYYY")
            : "",
        serviceProviderName: selectedServiceProvider.value,
        userId: selectedClient.value,
        userRefId: "",
        activeStatus: "",
        onBoardedStatus: APPROVED,
        serviceType: "",
      })
        .then((res) => {
          saveAs(res, "client.csv");
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error",
      });
    }
  };

  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative",
      }}
      className="hide-scroll-bar"
    >
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker
          value={toDate}
          onChange={setToDate}
          minDate={fromDate}
          disabled={fromDate ? false : true}
        />
      </div>

      {role !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
          />
        </div>
      )}

      {/* <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Select Service Type
        </label>

        <CustomSelect
          value={selectedClient}
          options={clientList}
          onChange={(data) => {
            setSelectedClient(data);
          }}
          placeholder="Select Service Type"
        />
      </div> */}

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Service Provider
        </label>

        <CustomSelect
          value={selectedServiceProvider}
          options={serviceProvider}
          onChange={(data) => {
            setSelectedServiceProvider(data);
          }}
          placeholder="Select Service Type"
        />
      </div>

      <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          onClick={onClickDownLoadReport}
          disabled={false}
        />
      </div>
    </div>
  );
};

export default DownloadReportClient;
